export class AuthProvider {
  Name: string;
  Url: string;
}
